export const PROPERTY_JIAMENG = 1 // 加盟店
export const PROPERTY_WEDDING_PLAN_ID = 2 // 婚礼策划
export const PROPERTY_WEDDING_PHOTO_ID = 6 // 婚纱摄影
export const PROPERTY_WEDDING_DRESS_ID = 12 // 婚纱礼服
export const PROPERTY_WEDDING_CEREMONY_ID = 7 //婚礼摄影
export const PROPERTY_HLSX_ID = 8 //婚礼摄像
export const PROPERTY_HLGZ_ID = 9 //婚礼跟妆
export const PROPERTY_WEDDING_SIYI_ID = 11 // 司仪
export const PROPERTY_HOTEL = 13 // 婚宴酒店
export const PROPERTY_RING = 14 // 婚戒首饰
export const PROPERTY_DESERT = 15 // 花艺甜品

export const PROPERTY_LIST = [
  { id: '2', name: '婚礼策划' },
  { id: '6', name: '婚纱摄影' },
  { id: '7', name: '婚礼摄影' },
  { id: '8', name: '婚礼摄像' },
  { id: '9', name: '婚礼跟妆' },
  { id: '11', name: '婚礼司仪' },
  { id: '12', name: '婚纱礼服' },
  { id: '13', name: '婚宴酒店' },
  { id: '14', name: '婚戒首饰' },
  { id: '15', name: '花艺甜品' }
]

export const PROPERTY_OBJ = {
  '2': '婚礼策划',
  '6': '婚纱摄影',
  '7': '婚礼摄影',
  '8': '婚礼摄像',
  '9': '婚礼跟妆',
  '11': '婚礼司仪',
  '12': '婚纱礼服',
  '13': '婚宴酒店',
  '14': '婚戒首饰',
  '15': '花艺甜品'
}

export const PROPERTY_WITH_WEDDING = [
  { id: '2', name: '婚礼策划' },
  { id: '6', name: '婚纱摄影' },
  { id: '7', name: '婚礼摄影' },
  { id: '8', name: '婚礼摄像' },
  { id: '9', name: '婚礼跟妆' },
  { id: '11', name: '婚礼司仪' },
  { id: '12', name: '婚纱礼服' },
  { id: '13', name: '婚宴酒店' },
  { id: '14', name: '婚戒首饰' },
  { id: '15', name: '花艺甜品' },
  { id: '1000', name: '婚品' }
]

export const PROPERTY_WITH_WEDDING_OBJ = {
  '2': '婚礼策划',
  '6': '婚纱摄影',
  '7': '婚礼摄影',
  '8': '婚礼摄像',
  '9': '婚礼跟妆',
  '11': '婚礼司仪',
  '12': '婚纱礼服',
  '13': '婚宴酒店',
  '14': '婚戒首饰',
  '15': '花艺甜品',
  '1000': '婚品'
}
export const CRAWLER_SOURCE = 2
